import { createSlice } from '@reduxjs/toolkit';
import { ManifestStagedShipmentState } from './types';
import { StoreStatus } from '../../core/types/common.types';
import { manifestStagedShipmentThunk } from './thunks';

// Initial State
const initialState: ManifestStagedShipmentState = {
  errors: null,
  status: StoreStatus.IDLE,
  response: null,
};

// Slice
export const manifestStagedShipmentSlice = createSlice({
  name: 'shipment',
  initialState,
  reducers: {
    resetManifestStagedShipment: () => ({
      ...initialState,
    }),
  },
  extraReducers: (builder) => {
    builder.addCase(manifestStagedShipmentThunk.pending.type, (state) => {
      state.status = StoreStatus.BUSY;
    });
    builder.addCase(manifestStagedShipmentThunk.fulfilled.type, (state, action: any) => {
      state.status = StoreStatus.IDLE;
      state.response = action.payload;
      state.errors = null;
    });
    builder.addCase(manifestStagedShipmentThunk.rejected.type, (state, action: any) => {
      state.status = StoreStatus.ERROR;
      state.errors = action.payload;
      state.response = null;
    });
  },
});

// Action creators
export const { resetManifestStagedShipment } = manifestStagedShipmentSlice.actions;
export * from './thunks';
export default manifestStagedShipmentSlice.reducer;
